export default function Footer() {
  return (
    <footer className="w-full section">
      <div className="container !max-w-none flex items-end">
        <div className="w-1/2 text-lg">
          <svg className="footer-logo w-[58px] h-[16px]">
            <use xlinkHref="#videri-logo" />
          </svg>
        </div>
        <div className="w-1/2 text-lg flex justify-end">
          <svg className="footer-logo w-[58px] h-[16px]">
            <use xlinkHref="#kerve-logo" />
          </svg>
        </div>
      </div>
    </footer>
  );
}
